export const GET_BIKES_FOR_PART_EX_REQUEST = 'GET_BIKES_FOR_PART_EX_REQUEST';
export const GET_BIKES_FOR_PART_EX_SUCCESS = 'GET_BIKES_FOR_PART_EX_SUCCESS';
export const GET_BIKES_FOR_PART_EX_FAILURE = 'GET_BIKES_FOR_PART_EX_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/constants/get_bikes_for_part_ex.constants.js